import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Companies from './pages/companies/Companies';
import CompanyDetails from './pages/company-details/CompanyDetails';
import AdminDashboard from './pages/dashboard/AdminDashboard';
import Consultants from './pages/consultants/Consultants';
import Login from './pages/login/Login'
import Protected from './components/protected/Protected';
import { AuthContext } from './contexts/AuthContext';
import { UserContext } from './contexts/UserContext';
import { useAuth } from './hooks/useAuth';
import Error404 from './pages/error-pages/Error404';
import Error403 from './pages/error-pages/Error403';
import Questionnaire from './pages/questionnaire/Questionnaire';
import { ConfigProvider } from 'antd';
import Review from './pages/review/Review';
import './fonts.css'


function App() {

  const { authObject, userInfo } = useAuth()

  return (
    <ConfigProvider theme={{
      "token": {
        // "colorPrimary": "#05b08a",
        colorPrimary: '#3BA4FE',
        "colorInfo": "#05b08a",
        // "colorBgBase": "#eef9d4",
        "colorBgBase":"#EBF6FF",
        "colorBgContainer": "#ffffff",
        // "colorBgContainer": "#EBF6FF",
        "colorBgElevated": "#ffffff",
        "colorBorder": "#d9d9d9"
      }
    }}>
    <Router>
      <AuthContext.Provider value={authObject}>
        <UserContext.Provider value={userInfo}>
          <Routes>
            {/* Home */}
            <Route path='/' element={<Protected>{userInfo?.role === 'admin' ? <Navigate to='/consultants'/> : <Navigate to='/companies'/>}</Protected>} />

            {/* Consultant routes */}
            <Route path='/companies' element={<Protected>{userInfo?.role === 'consultant' ? <Companies/> : <Error404/>}</Protected>} />
            <Route path='/company/:companyId' element={<Protected>{userInfo?.role === 'consultant' ? <CompanyDetails/> : <Error404/>}</Protected>} />
            <Route path='/company/:companyId/questionnaire/:readinessIndexType' element={<Protected>{userInfo?.role === 'consultant' ? <Questionnaire/> : <Error403/>}</Protected>} />
            <Route path='/company/:companyId/questionnaire/:readinessIndexType/review' element={<Protected>{userInfo?.role === 'consultant' ? <Review/> : <Error403/>}</Protected>} />

            {/* Admin routes */}
            <Route path='/consultants' element={<Protected>{userInfo?.role === 'admin' ? <Consultants/> : <Error404/>}</Protected>} />
            <Route path='/consultant/:consultantId/companies' element={<Protected>{userInfo?.role === 'admin' ? <Companies/> : <Error404/>}</Protected>} />
            <Route path='/consultant/:consultantId/company/:companyId' element={<Protected>{userInfo?.role === 'admin' ? <CompanyDetails/> : <Error404/>}</Protected>} />
            <Route path='/consultant/:consultantId/company/:companyId/questionnaire/:readinessIndexType/review' element={<Protected>{userInfo?.role === 'admin' ? <Review/> : <Error404/>}</Protected>} />
            
            {/* Unprotected routes */}
            <Route path='/login' element={<Login/>} />
            <Route path='*' element={<Error404/>} />
          </Routes>
        </UserContext.Provider>
      </AuthContext.Provider>
    </Router>
    </ConfigProvider>
  );
}

export default App;
